// extracted by mini-css-extract-plugin
export var searchHeader = "_48-0";
export var searchHeaderDark = "_48-1";